module.exports = __webpack_public_path__ + "img/face7.13cb59b7.gif";